import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { LazyIntegrationList } from './async.tsx';

export const IntegrationList = (): React.JSX.Element => (
	<LazyPage
		Page={LazyIntegrationList}
		pageId="async-jira-eoc-integration-automation"
		shouldShowSpinner
	/>
);
